export default {"src":"/_next/static/media/protect-yourself.2147c745.svg","height":240,"width":220,"blurWidth":0,"blurHeight":0};